var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRulerCombined = function SvgRulerCombined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.4 18.4h-.8V3.2H3.2v25.6h25.6V18.4zm8 .8V24h.8v-4.8H28V28H4V4h8.8v4.8H8v.8h4.8v4H8v.8h4.8v4H8v.8h4.8V24h.8v-4.8h4V24h.8v-4.8z"
  })));
};
export default SvgRulerCombined;